export default __webpack_public_path__ + "static/media/imgLightEn4.1a964e54.png";